import { Container } from 'components/box';
import dynamic from 'next/dynamic';

const MyOrders = dynamic(() => import('components/my-orders/all-orders'), {
  ssr: false,
});

const Index = () => (
  <Container>
    <MyOrders />
  </Container>
);

export default Index;
